import { useEffect, useState } from "react"
import WithSidebar from "../../../layouts/WithSidebar"
import './send.css'

import { useLocation } from "react-router-dom"
import { ajax } from "../../../scripts/helper"
import { useSnackbar } from 'notistack'
import utils from "../../../scripts/utils"
import { useNavigate } from "react-router-dom"



const SendToPos = () => {
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()
    

    const {state } = useLocation()
    const [response, setResponse] = useState({})
    
    const getCurrencyAndProduct = async() => {
            const res = await ajax({
                method: 'GET',
                url: utils.urls.linkDetail(state.id),
                hasToken: true,
                snackbar: enqueueSnackbar
            })
    
            if (!res) return
    
            console.log(res, 'dataaaaaaaaaa')
    
            setResponse(res.data)

            console.log(response, 'response')
        
    }
    
    const sendToPos = async () => {
        const res = await ajax({
            method: 'GET',
            url: utils.urls.publishTransaction(state.id),
            hasToken: true,
            snackbar: enqueueSnackbar
        })

        if(!res) return

        enqueueSnackbar("Sent to POS successfully", {variant: 'success'})
        navigate('/agent/payments', {replace: true})
    }
    
    
    
    useEffect( () => {
        getCurrencyAndProduct()

    }, [state])

    
    return(
        <WithSidebar pageTitle={"Send Message"} breadcrumb={" Dashboard > Payment link > Create link > Send link"} >
            <div className="link-detail">
                <div className="link-value-label">
                    <label>Value</label>
                </div>
                <div className="link-amount">
                    <p className="p2">{state.amount.toLocaleString()}</p>
                    <p className="p1">{(response && response.currency ? response.currency.code : '')}</p>
                    
                </div>
                <div className="link-row">
                    <div className="link-first">
                        <label>Office</label>
                        <span>{state.primaryContact}</span>
                    </div>
                    <div className="link-second">
                        <label>Terminal</label>
                        <span>{(response && response.account ? response.account.name : '')}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first"> 
                    <label>Product</label>
                        <span>{(response && response.product ? response.product.name : '')}</span>
                    </div>
                    <div className="link-second">
                        <label>Reference</label>
                        <span>{state.reference}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first"> 
                    <label>Contact Person</label>
                        <span>{state.primaryContact }</span>
                    </div>
                    <div className="link-second">
                        <label>Mobile</label>
                        <span>{state.mobile}</span>
                    </div>
                </div>
                <div className="link-row">
                    <div className="link-first"> 
                    <label>Email</label>
                        <span>{state.email}</span>
                    </div>
                    
                </div>
                
            </div>
            <div className="send-btn-container">
                <button className="back" onClick={() => navigate('/agent/payments', {replace: true})}>Back</button>
                <button className="send" onClick={() => sendToPos()}>Send To POS</button>
            </div>

        </WithSidebar>
    )
}
export default SendToPos